module.exports = __webpack_public_path__ + "img/games.f9ccb7f6.jpg";